import { memo } from 'react';
import stylex from '@stylexjs/stylex';
import { ParticipantCardNoSegment } from '@features/participant-card-no-segment';
import { Ticket } from '@pages/event/api/useFetchTicketSegment';
import { EventSettings } from '@features/api/use-get-settings';
import { styles } from '../styles';

interface SegmentParticipantRowProps {
  ticket: Ticket;
  isFreelance?: boolean;
  checked: boolean;
  eventId?: number;
  eventDateEnd?: string;
  eventDateStart?: string;
  showRegistration?: boolean;
  eventSettings?: EventSettings | null;
  checkedUsers?: { [key: number]: number };
  onToggle: (ticket: Ticket) => void;
  onDelete: (ticket: Ticket) => Promise<void> | void;
  onGetTicketQR: (ticketId: number) => void;
  refetchSegments: () => void;
  refetchCategories?: () => void;
}

const truncateText = (text: string) => {
  return text?.length > 18 ? `${text.slice(0, 18)}...` : text;
};

export const SegmentParticipantRow = memo(function SegmentParticipantRow({
  ticket,
  isFreelance = false,
  checked,
  eventId,
  eventDateEnd,
  eventDateStart,
  eventSettings,
  showRegistration,
  checkedUsers,
  onToggle,
  onDelete,
  onGetTicketQR,
  refetchSegments,
  refetchCategories,
}: SegmentParticipantRowProps) {
  const isDisabled = !ticket.participant?.active;
  const position = isFreelance && isDisabled ? 'Больше не работает' : ticket.participant?.position ?? undefined;
  const name = `${truncateText(ticket.participant?.firstName ?? '')} ${truncateText(ticket.participant?.lastName ?? '')}`;
  const hasGuests = Boolean(
    ticket.dependents && (ticket.dependents.countExtraAdult || ticket.dependents.countExtraChildren)
  );

  return (
    <div {...stylex.props(styles.row)}>
      <ParticipantCardNoSegment
        ticket={ticket}
        position={position}
        name={name}
        checked={checked}
        disabled={isDisabled}
        onToggle={() => onToggle(ticket)}
        onDelete={() => onDelete(ticket)}
        getTicketQR={() => onGetTicketQR(ticket.id)}
        eventId={eventId}
        eventDateEnd={eventDateEnd}
        eventDateStart={eventDateStart}
        refetchSegments={refetchSegments}
        refetchCategories={refetchCategories}
        toggleUser={onToggle}
        handleDelete={onDelete}
        checkedUsers={hasGuests ? checkedUsers : undefined}
        showRegistration={showRegistration}
        eventSettings={eventSettings}
      />
    </div>
  );
});
